module.exports = __webpack_public_path__ + "img/31.587fc87c.png";